import _ from 'lodash';

import {MeshScene, FormabilityScene, BlankScene, NestScene} from './scenes';

const ThreeJsView = ($state, $window, LoadedModel) => ({
    restrict: 'A',
    link($scope, $element) {

        let renderer, scene, camera, viewData;
        let renderElement = $element[0];

        let parent = $element.parent().parent().parent()[0];

        let [width, height] =  getSideLength();
        function getSideLength() {

            return [
                parent.clientWidth ? parent.clientWidth - 25: 0,
                parent.clientHeight ? parent.clientHeight - 80: 0
            ];
        }

        function onResize() {
            [width, height] = getSideLength();
            processData(viewData);
            drawView();
        }

        function saveCameraPosition() {
            if (LoadedModel.currentView && LoadedModel.currentView.viewType === 'free') {
                LoadedModel.position.free = camera.position;
            } else if (LoadedModel.currentView && LoadedModel.currentView.viewType === 'blank') {
                LoadedModel.position.blank = camera.position;
            } else if (LoadedModel.currentView && LoadedModel.currentView.viewType === 'nest') {
                LoadedModel.position.nest = camera.position;
            }
        }

        function render() {
            if(LoadedModel.animationId) {
                cancelAnimationFrame(LoadedModel.animationId);
            }
            LoadedModel.animationId =  requestAnimationFrame(render);
            let axis = _.get(LoadedModel, 'currentView.axis', false);
            let currentView = LoadedModel.currentView;
            if (currentView) {
                currentView.setLightPosition(camera);
            }
            if (axis) {
                axis.setPosition(camera);
            }

            renderer.setSize(width, height);
            saveCameraPosition();
            if (renderer) {
                renderer.render(scene, camera);
            }
        }

        function drawView() {
            if (renderElement.children.length) {
                renderElement.removeChild(renderElement.children[0]);
            }
            saveCameraPosition();

            camera.lookAt(scene.position);
            render();
            renderElement.appendChild(renderer.domElement);
        }

        function processData(sceneAndData) {
            let [data, view, type, force, offset] = sceneAndData;

            const sceneMapper =  {
                mesh: MeshScene,
                feasibility: FormabilityScene,
                thinning: FormabilityScene,
                blank: BlankScene,
                nest: NestScene,
            };
            if (view) {
                LoadedModel.currentView = view;
                if(force) {
                    LoadedModel.currentView = new sceneMapper[type](view.data, width, height, LoadedModel.position, offset);
                } else {
                    LoadedModel.currentView.restoreView(width, height, LoadedModel.position);
                }

                scene = LoadedModel.currentView.scene;
                camera = LoadedModel.currentView.camera;
                renderer = LoadedModel.currentView.renderer;

            } else {
                LoadedModel.currentView = new sceneMapper[type](data, width, height, LoadedModel.position);
                scene = LoadedModel.currentView.scene;
                camera = LoadedModel.currentView.camera;
                renderer = LoadedModel.currentView.renderer;
                LoadedModel.updateView(LoadedModel.currentView, type);
            }
        }

        $scope.$on('updateView', function (event, data) {
            processData(data);
            viewData = data;
            drawView();
        });


        $scope.$on('meshDeleted', function() {
            LoadedModel.clearCurrentView();
        });

        angular.element($window).bind('resize', function() {
            onResize();
        });
    }
});

ThreeJsView.$inject = ['$state', '$window', 'LoadedModel'];

export default ThreeJsView;



// WEBPACK FOOTER //
// ./client/app/common/model-view/threejs-view.directive.js